/* tslint:disable */

/* eslint-disable */

/**
 * Title
 * Title
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';

/**
 *
 * @export
 * @interface CountryInfo
 */
export interface CountryInfo {
    /**
     *
     * @type {string}
     * @memberof CountryInfo
     */
    code?: string;
    /**
     *
     * @type {string}
     * @memberof CountryInfo
     */
    label?: string;
    /**
     *
     * @type {string}
     * @memberof CountryInfo
     */
    phone?: string;
}

export function CountryInfoFromJSON(json: any): CountryInfo {
    return CountryInfoFromJSONTyped(json, false);
}

export function CountryInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CountryInfo {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        code: !exists(json, 'code') ? undefined : json['code'],
        label: !exists(json, 'label') ? undefined : json['label'],
        phone: !exists(json, 'phone') ? undefined : json['phone'],
    };
}

export function CountryInfoToJSON(value?: CountryInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        code: value.code,
        label: value.label,
        phone: value.phone,
    };
}
